import { DividerModel } from '@_types/atoms';
import { getModifiers } from '@helpers/functions';

const Divider = (model: DividerModel) => {
  const styleModifier = getModifiers(model, 'kf-a-divider');

  return <div className={styleModifier} />;
};

export default Divider;
